import { render, staticRenderFns } from "./PorletFormulario.vue?vue&type=template&id=0c52bf5a"
import script from "./PorletFormulario.vue?vue&type=script&lang=js"
export * from "./PorletFormulario.vue?vue&type=script&lang=js"
import style0 from "./PorletFormulario.vue?vue&type=style&index=0&id=0c52bf5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports